module.exports = __webpack_public_path__ + "static/wood_woad-9f0adbd46eb7dcd31e9ddb48f1710f85.jpeg";